import React, { Component } from "react";
import Autobind from "autobind-decorator";
import { inject, observer } from "mobx-react";
import ControlPanel from "component/molecules/controlPanel";
import AnalysisPanel from "component/molecules/AnalysisPanel";
import OpacityPanel from "component/molecules/opacityPanel";
import MeasurementPanel from "component/molecules/measurementPanel";
import ExportPanel from "component/molecules/exportPanel";

import brushModule from "component/molecules/viewport/tools/annotation/brushTool/brushModule";
import Scrollbar from "react-scrollbars-custom";
import "./controlSection.styl";
import "./customScroll.styl";

import "rc-tooltip/assets/bootstrap.css";
/**
 * @description ControlSection UI Class Component
 *
 * @class ControlSection
 * @extends {Component<IControlSectionProps, any>}
 */
@inject("panelControlStore")
@observer
@Autobind
class ControlSection extends React.Component {
  /**
   * @method render
   * @description ControlSection UI 컴포넌트 렌더링
   * @returns
   * @memberof ControlSection
   */
  render() {
    
    const { panelControlStore, closeProfileMenu  } = this.props;
    const {
      ControlPanel: controlPanelDisabled,
      AnalysisPanel: analysisPanelDisabled,
      OpacityPanel: opacityPanelDisabled,
      MeasurementPanel: measurementPanelDisabled,
      ExportPanel: exportPanelDisabled
    } = panelControlStore.getAllPanelDisableState();

    const alphaPercentage =
      (brushModule.getters.useColorSetAlpha() / 255) * 100;

    return (
      <div className="control-section">
        <Scrollbar
          noDefaultStyles
          permanentTrackX={true}
          permanentTrackY={false}
          noScrollX={false}
        >
          <div className="controlSection__from-top">
            <ControlPanel disabled={controlPanelDisabled} />

            <AnalysisPanel
              disabled={analysisPanelDisabled}
              closeProfileMenu={closeProfileMenu} // ✅ 전달!
            />

            <OpacityPanel
              opacity={alphaPercentage}
              disabled={opacityPanelDisabled}
            />
            <MeasurementPanel disabled={measurementPanelDisabled} />
          </div>
          <div className="controlSection__from-bottom">
            <ExportPanel disabled={exportPanelDisabled} />
          </div>
        </Scrollbar>
      </div>
    );
  }
}

export default ControlSection;
